import React from 'react';
import logo from '../assests/img/bridge-logo.png';
import mobilelogo from '../assests/img/bridge-logo.png';
import Topmenuleft from './Topmenuleft';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaFacebook, FaHeadphones } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { useState, useEffect } from "react";
import Mobilemenu from './Mobilemenu';
import SearchBox from './SearchBox';
import { IoMdClose } from "react-icons/io";
import { FiSearch } from "react-icons/fi";


function Header() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const location = useLocation();
  const isContactActive = location.pathname === '/contact';

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isDarkMode]);

  useEffect(() => {
    setIsDarkMode(false);
    setIsSearchOpen(false);
  }, [location.pathname]);


  return (
    <>
      <header>
        <div className='top-bar'>
            <div className='container'>
             <div className='row'>
          <div className='col-md-6'>
              <div className='top-social'>

                <ul className='flex'>
                  <li> <a href="https://www.facebook.com/labway.scientific.7" target="_blank"><FaFacebook /></a></li>
                               {/* <li>  <a href="#"><FaYoutube /></a></li>
                               <li>  <a href="#"><FaInstagram /></a></li> */}
                </ul>

            </div>
          </div>

          <div className='col-md-6'>
              <div className='top-contact'>
          <ul className='flex'>                  
                   <li>  <a href="mailto:info@labwayscientific.com">
                            info@labwayscientific.com
                          </a>
                          </li>

                            <li><FaWhatsapp />  <a href="tel:+91-92066-91066">
                           +91-92066-91066
                          </a>
                          </li>
                </ul>

          </div>
          </div>
           
        </div>
        </div>

        </div>
      
        
      <div className='container inner-header'>
       
        <div className='row'>
          <div className='col-md-2 upcoming-event-box'>
         

             <Link to='/home' className='logo-img-box'>
            <img className='main-logo' src={logo}/>           
            </Link>

            <div className="header-mobile-actions">
              <button
                type="button"
                className="mobile-search-btn"
                aria-label="Open search"
                onClick={() => setIsSearchOpen((open) => !open)}
              >
                {isSearchOpen ? <IoMdClose /> : <FiSearch />}
              </button>
              <button className='menu-toggle-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 12L10 12" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20 5L4 5" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20 19L4 19" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
           </button>
            </div>
         
             
                 
          </div>
          <div className={`col-md-7 main-logo-box search-col${isSearchOpen ? " is-mobile-open" : ""}`}>
         

         

           <div className="header-element search-wrap">
             <SearchBox
               forceOpen={isSearchOpen}
               onClose={() => setIsSearchOpen(false)}
             />
           </div>

          </div>


          <div className='col-md-3 download-box-header'>    

      <div><p class="xl:flex lg:items-center gap-x-4 hidden"><span class="help-icon-box size-12 inline-flex items-center justify-center rounded-full transition-colors duration-300">
        
        <FaHeadphones/>
        <i class="hgi hgi-stroke hgi-customer-support text-2xl text-light-primary-text"></i></span><span class="flex flex-col text-sm leading-[22px]">24/7 Support<span class="text-base leading-6 text-light-primary-text">888-777-999</span></span></p></div>

      
        
       
          </div>
        </div>

       
      </div>


      <div className="main-menu">
        <div className="container">
               <div className='row'>
         
      <Topmenuleft/>     
        
        </div>
        </div>
            
      </div>

      

      <div className='mobile-menu'>
      <button className='menu-close-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
      <IoMdClose />
          </button>
        <Mobilemenu/>
      </div>
    
      </header>
     
      </>
  )

}

export default Header;
